<template>
  <div class="article-error">
    <img src="../assets/images/forbidden.png" alt="" class="error-img"/>
    <p class="error-tip">{{$t('lang.onlyMeixinCanOpen')}}</p>
    <div>
      <button class="button" @click="openApp">{{$t('lang.open')}}</button>
    </div>
    <div style="position: fixed;
      top: 0;left: 0;
      bottom: 0;right: 0;
      background-color: rgba(0,0,0,.5);
      z-index: 10002;"
      v-if="isWeixinBrowser && invalid">
        <div v-if="!isPC">
          <img src="../assets/images/WechatIMG660.png" alt="" style="width: 100%;">
        </div>
        <div v-else>
          <img src="../assets/images/guide.png" style="margin-left: 60px;width: 77px;" alt="">
          <span style="color: white;position: relative;">1、点击左上角浏览器图标，在浏览器中打开
            
          </span>
          <div style="display: inline-block;position: relative;">
            <img src="../assets/images/Internet.png" style="position: absolute;width: 34px;top: -22px;" alt="">
          </div>
          <div style="display: inline-block;position: relative;">
            <img src="../assets/images/hand.png" style="position: absolute;width: 30px;left: 20px;top: 10px;" alt="">
          </div>
        </div>
        
      </div>
  </div>
</template>

<script>
import { isMideaConnect, isiOS, isArd, isPC, isWeixinBrowser } from'../utils/utils'
const PROJECT_CONFIG = require('../../config')
export default {
  data () {
    return {
      PCProtocol: '',
      mobileProtocol: '',
      redirectUrl: 'https://im.midea.com/',
      urlScheme: '',
      invalid: false
    }
  },
  computed: {
    isWeixinBrowser () {
      return isWeixinBrowser()
    },
    isPC () {
      return isPC()
    }
  },
  methods: {
    openApp () {
      if (this.isWeixinBrowser) {
        this.invalid = true
        return
      }
      console.log(decodeURIComponent(this.$route.query.redirectedUrl))
      if (!isMideaConnect() && isPC()) {
        const url = `${this.PCProtocol}platformapi/browser?url=${decodeURIComponent(this.$route.query.redirectedUrl)}`
        window.protocolCheck(url, () => {
          const clickUp = window.confirm('没有该应用，是否去下载')
          if (clickUp) window.location.href = this.redirectUrl
        })
      } else if (!isMideaConnect() && isArd()) {
        // window.location.href = `missiontest://platformapi/browser?url=${decodeURIComponent(this.$route.query.redirectedUrl)}`
        const url = `${this.mobileProtocol}platformapi/browser?url=${decodeURIComponent(this.$route.query.redirectedUrl)}`
        this.schemeUrl(url, () => {
          if (document.hidden === false) window.location.href = this.redirectUrl
        })
      } else if (!isMideaConnect() && isiOS()) {
        const url = `${this.mobileProtocol}platformapi/browser?url=${decodeURIComponent(this.$route.query.redirectedUrl)}`
        this.iosSchemeUrl(url, () => {
          let hidden
          if (typeof document.hidden !== 'undefined') {
            hidden = 'hidden'
          } else if (typeof document.mozHidden !== 'undefined') {
            hidden = 'mozHidden'
          } else if (typeof document.msHidden !== 'undefined') {
            hidden = 'msHidden'
          } else if (typeof document.webkitHidden !== 'undefined') {
            hidden = 'webkitHidden'
          }
          console.log('document[hidden]的值', document[hidden])
          window.location.href = this.redirectUrl
        })
      } else {
        console.log('未知错误')
      }
    },
    schemeUrl (url, callback) {
      const ifr = document.createElement('iframe')
      ifr.src = url
      ifr.style.display = 'none'
      document.body.appendChild(ifr)
      //app没反应1s后执行另外的方法
      window.setTimeout(function () {
        document.body.removeChild(ifr)
        if (typeof callback === 'function') { callback() }
      }, 2000)
    },
    iosSchemeUrl (url, callback) {
      window.location.href = url
      window.setTimeout(() => {
        if (typeof callback === 'function') { callback() }
      }, 2000)
    },
    weixinShare () {
      if (window.isWxTagLaunch) {
        window.initTagExtinfo()
        window.wx.ready(function () {
          console.log('wx ready')
          window.wx.onMenuShareAppMessage({
            title: 'Midea News',
            link: window.location.href,
            imgUrl: '',
            desc: '这个内容只能通过美信打开哦',
            success: function () {
              console.log('share app message success!!!')
            }
          })
          window.wx.onMenuShareTimeline({
            title: 'Midea News',
            link: window.location.href,
            imgUrl: '',
            success: function () {
              console.log('share timeline success!!!')
            }
          })
        })
      }
    }
  },
  created () {
    this.$store.dispatch('setShowLoadingPic', { showLoadingPic: false })
    if (PROJECT_CONFIG.baseUrl.indexOf('sit') > -1) {
      this.PCProtocol = 'meicloudsit://'
      this.mobileProtocol = 'missiontest://'
      this.redirectUrl = 'https://uomsit.midea.com/h5-dev-page-mx2/pcv5.html'
    } else {
      this.PCProtocol = 'meicloud://'
      this.mobileProtocol = 'mideaconnect://'
      this.redirectUrl = 'https://im.midea.com/'
    }
    if (!isMideaConnect() && isPC()) {
      this.urlScheme = `${this.PCProtocol}platformapi/browser?url=${decodeURIComponent(this.$route.query.redirectedUrl)}`
    } else if (!isMideaConnect() && (isArd() || isiOS())) {
      this.urlScheme = `${this.mobileProtocol}platformapi/browser?url=${decodeURIComponent(this.$route.query.redirectedUrl)}`
    }
  },
  mounted () {
    if (this.isWeixinBrowser) this.weixinShare()
  }
}
</script>

<style scoped>
  .article-error {
    height: 100vh;
    background-color: #F5F5F5;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .error-img {
    width: 7.5rem;
    height: 7.5rem;
  }
  .error-tip {
    color: #919ca3;
    font-size: .875rem;
    margin: .5rem 0;
  }

  @media screen and (min-width:769px){
    .error-tip {
      font-size: 1rem;
    }
  }
</style>